<template>
  <div class="modal-overlay" @click.self="emit('cancel')">
    <div class="modal-box">
      <h3 class="modal-title">Onaylıyor musunuz?</h3>
      <p class="modal-message">{{ message }}</p>
      <div class="modal-actions">
        <button class="btn red" @click="emit('confirm')">Evet, Sil</button>
        <button class="btn gray" @click="emit('cancel')">İptal</button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  message: {
    type: String,
    default: 'Bu işlemi silmek istediğinizden emin misiniz?'
  }
})
const emit = defineEmits(['confirm', 'cancel'])
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-box {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.modal-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.modal-message {
  font-size: 14px;
  color: #444;
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.btn {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.btn.red {
  background-color: #e74c3c;
  color: white;
}

.btn.gray {
  background-color: #ccc;
  color: #333;
}
@media (max-width: 480px) {
  .modal-box {
    width: 95%;
    padding: 16px;
  }

  .modal-title {
    font-size: 18px;
  }

  .modal-message {
    font-size: 13px;
  }

  .modal-actions {
    flex-direction: column;
    gap: 8px;
  }

  .btn {
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }
}
</style>
